import { language, languages, currency, Slugs } from './constants'
import { getLocation } from './utils'
import { isSSR } from 'js/isSSR'

const isValidLanguage = lang => {
  return languages.includes(lang)
}

/**
 * Method to determine the preferred language for the user.
 * @returns a string describing the user's preferred locale, based on browser info
 */
export const getUserLanguage = (stored, url, ssrAcceptedLanguages = null) => {
  const pathname = url || getLocation().pathname

  const slugLanguage = languages.find(
    lang =>
      (pathname.length === 3 &&
        pathname.toLowerCase().slice(0, 3) === '/' + lang) ||
      pathname.toLowerCase().slice(0, 4) === '/' + lang + '/'
  )

  if (slugLanguage && isValidLanguage(slugLanguage)) {
    return slugLanguage
  }

  if (stored) return stored

  const browserLanguage = (
    (isSSR ? ssrAcceptedLanguages : navigator.languages) || []
  )
    .map(language => language.toLowerCase().substr(0, 2))
    .map(language => (language === 'nb' ? 'no' : language))
    .find(language => isValidLanguage(language))

  if (browserLanguage) return browserLanguage

  return language.ENGLISH
}

export const getCurrencyFromCountry = country => {
  return (
    {
      AD: currency.EUR,
      AL: currency.EUR,
      AT: currency.EUR,
      AX: currency.EUR,
      BA: currency.EUR,
      BE: currency.EUR,
      BG: currency.EUR,
      BY: currency.EUR,
      CH: currency.CHF,
      CY: currency.EUR,
      CZ: currency.EUR,
      DE: currency.EUR,
      DK: currency.DKK,
      EE: currency.EUR,
      ES: currency.EUR,
      FI: currency.EUR,
      FO: currency.EUR,
      FR: currency.EUR,
      GB: currency.GBP,
      GG: currency.EUR,
      GI: currency.EUR,
      GR: currency.EUR,
      HR: currency.EUR,
      HU: currency.EUR,
      IE: currency.EUR,
      IM: currency.EUR,
      IS: currency.EUR,
      IT: currency.EUR,
      JE: currency.EUR,
      LI: currency.EUR,
      LT: currency.EUR,
      LU: currency.EUR,
      LV: currency.EUR,
      MC: currency.EUR,
      MD: currency.EUR,
      ME: currency.EUR,
      MK: currency.EUR,
      MT: currency.EUR,
      NL: currency.EUR,
      NO: currency.NOK,
      PL: currency.EUR,
      PT: currency.EUR,
      RO: currency.EUR,
      RS: currency.EUR,
      RU: currency.EUR,
      SE: currency.SEK,
      SI: currency.EUR,
      SJ: currency.EUR,
      SK: currency.EUR,
      SM: currency.EUR,
      UA: currency.EUR,
      VA: currency.EUR,
      XK: currency.EUR,
      NZ: currency.NZD,
      AU: currency.AUD,
    }[country] || currency.USD
  )
}

export const translateCategory = category => {
  let translatedCategory

  for (let slug in Slugs) {
    for (let lang in Slugs[slug]) {
      if (Slugs[slug][lang] === category) {
        translatedCategory = slug
      }
    }
  }

  return translatedCategory
}
